import { InjectionToken } from '@angular/core';

export const GRECAPTCHA_SITE_KEY = new InjectionToken('GRECAPTCHA_SITE_KEY');
